export const config = {
  title: "Salas Remodeling Services",
  meta: {
    description:
      "Salas Remodeling Services offers expert remodeling, painting, flooring, and drywall services in Albuquerque, NM. Quality craftsmanship and reliable service for your home improvement needs.",
    keywords: [
      "Remodeling Albuquerque",
      "Drywall Installation",
      "Interior Painting",
      "Flooring Services",
      "Home Renovation Albuquerque",
      "Salas Remodeling Services",
    ],
    author: "Salas Remodeling Services",
    canonicalUrl: "https://www.salasremodeling.com/",
  },
  sections: {
    header: {
      businessName: "Salas Remodeling Services",
    },
    sectionB: {
      heroTitle: "Salas Remodeling Services",
      heroSubtitle: "Remodeling • Painting • Flooring • Drywall in Albuquerque, NM",
      learnAboutText: "Explore Our Services",
      phoneNumber: "5053618672",
      phoneLabel: "(505) 361-8672",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/155387953/photo/man-installing-plasterboard.jpg?s=612x612&w=0&k=20&c=bsYAbGJQZRBRqu-tIy_95jLkVZY-ADRH3lFSOiFFkGQ=",
      cardData: [
        {
          title: "Home Remodeling",
          description:
            "From bathrooms to kitchens, we turn your vision into reality with skilled renovations.",
        },
        {
          title: "Painting Services",
          description:
            "Interior and exterior painting that refreshes and protects your home.",
        },
        {
          title: "Flooring & Drywall",
          description:
            "Professional flooring installation and drywall repair done right the first time.",
        },
      ],
      description:
        "Salas Remodeling Services is a trusted home renovation contractor based in Albuquerque, NM. We specialize in remodeling, painting, drywall, and flooring services, delivering results that enhance both form and function in your living space.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We offer a full suite of remodeling and renovation services tailored to your home improvement goals.",
      cards: [
        {
          title: "Bathroom Remodeling",
          description: "Custom tile work, fixtures, and updates to revamp your bathroom.",
          imageSrc: "https://media.istockphoto.com/id/1345670554/photo/latin-american-plumber-fixing-a-toilet-in-the-bathroom.jpg?s=612x612&w=0&k=20&c=YPOBAW4scHqOcY2e-kW6AHDvc1ypEAtgJ8Do1DiuJXA=",
          imageAlt: "Bathroom Remodeling",
        },
        {
          title: "Interior Painting",
          description: "Clean, efficient, and long-lasting painting for walls, ceilings, and trim.",
          imageSrc: "https://media.istockphoto.com/id/1461683093/photo/man-painting-wall-with-light-blue-dye-indoors-back-view.jpg?s=612x612&w=0&k=20&c=TDg87xVDJh-VA4zVClGlMnqpdqTh2QcZ--raihCv9XU=",
          imageAlt: "Interior Painting",
        },
        {
          title: "Drywall Installation & Repair",
          description: "Seamless drywall work that provides a clean and professional finish.",
          imageSrc: "https://media.istockphoto.com/id/887501420/photo/hands-of-the-ceiling-technician.jpg?s=612x612&w=0&k=20&c=dGoLh_B3DBAsmoKXq2MvxaAsEUBNcIqnc3LutZRv9HY=",
          imageAlt: "Drywall Installation",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Kitchen Remodeling",
        "Laminate & Tile Flooring",
        "Popcorn Ceiling Removal",
        "Texturing",
        "Exterior Painting",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1992657656/photo/house-or-apartment-indoor-improvements-and-repairs-works-in-the-very-beginning-construction.jpg?s=612x612&w=0&k=20&c=1WYFdXIuHR9BFmKSyw0SvuCgMJgYQ-kxnW8caQ5NEbg=",
        alt: "Salas Remodeling Services Team",
      },
      aboutText: [
        "Salas Remodeling Services has built a strong reputation for delivering top-notch residential remodeling and handyman work in Albuquerque, NM.",
        "With years of hands-on experience, we value quality craftsmanship, transparent communication, and client satisfaction on every project — big or small.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Salas Remodeling Logo",
      businessName: "Salas Remodeling Services",
      contact: {
        phone: "5053618672",
        phoneLabel: "(505) 361-8672",
        email: "Luisnegrete1022@gmail.com",
        website: "https://www.salasremodeling.com/",
        address: "2408 Sun Gate Trail SW, Albuquerque, NM 87121",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "2408 Sun Gate Trail SW, Albuquerque, NM 87121",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3267.04!2d-106.747!3d35.0466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87221d1d9c2b9f2b%3A0xabcdef1234567890!2s2408%20Sun%20Gate%20Trail%20SW%2C%20Albuquerque%2C%20NM%2087121!5e0!3m2!1sen!2sus!4v1715612345678!5m2!1sen!2sus",
    },
  },
};

export default config;
